import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface StatItem {
  label: string;
  value: number;
  icon: string;
  iconColor: string;
  bgColor: string;
  change?: string;
  changeType?: 'up' | 'down' | 'neutral';
}

interface DashboardStatsProps {
  stats: StatItem[];
}

const DashboardStats = ({ stats }: DashboardStatsProps) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, idx) => (
        <div key={idx} className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 flex items-start gap-3">
          <div className={`flex items-center justify-center w-10 h-10 rounded-lg flex-shrink-0 ${stat.bgColor}`}>
            <Icon name={stat.icon as any} size={20} variant="solid" className={stat.iconColor} />
          </div>
          <div className="min-w-0">
            <p className="text-2xl font-heading font-700 text-text-primary leading-tight">{stat.value}</p>
            <p className="text-xs font-caption text-text-secondary mt-0.5 leading-tight">{stat.label}</p>
            {stat.change && (
              <p className={`text-xs font-caption mt-1 ${stat.changeType === 'up' ? 'text-success' : stat.changeType === 'down' ? 'text-error' : 'text-text-secondary'}`}>
                {stat.change}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;
export type { StatItem };